import React from 'react';

export default function Header({ onToggleSidebar, onLogout }) {
  return (
    <header className="header">
      <button className="menu-btn" onClick={onToggleSidebar}>☰</button>
      <h3>لوحة تحكم مغسلة السيارات المتنقلة</h3>
      <button className="logout-btn" onClick={onLogout}>
        خروج 🚪
      </button>
    </header>
  );
}
